import React from 'react';
import PerformanceTable from './components/PerformanceTable';
import PortfolioConfigData from 'config/portfolio-config.json';
import styles from 'pages/assistant/components/artifacts/components/fineco-portfolio/finecoPortfolio.common.module.scss';
import { useTranslation } from 'react-i18next';
import MatriceDiCorrelazione1y from './components/MatriceDiCorrelazione1y';
import { useComparisonLabels } from '../../compare/ComparisonLabelsContext';

type SectionChildrenProps = { reportData: any; reportData2?: any };
const AnalisiStrumentiContainer: React.FC<SectionChildrenProps> = ({ reportData, reportData2 }) => {
  const { t } = useTranslation();
  const labels = useComparisonLabels();
  if (!reportData) {
    return <></>;
  }
  const configData = PortfolioConfigData.analisi_strumenti.data;

  const matriceData = {
    data: reportData.analisi_strumenti.matrice_di_correlazione_1y,
    isin: reportData.analisi_strumenti.matrice_di_correlazione_1y_isin,
    legend: reportData.analisi_strumenti.matrice_di_correlazione_1y_legend,
  };
  let matriceData2 = null;
  if (reportData2) {
    matriceData2 = {
      data: reportData2.analisi_strumenti.matrice_di_correlazione_1y,
      isin: reportData2.analisi_strumenti.matrice_di_correlazione_1y_isin,
      legend: reportData2.analisi_strumenti.matrice_di_correlazione_1y_legend,
    };
  }

  return (
    <>
      {!reportData2 && (
        <div style={{ marginBottom: 10, marginLeft: 5 }}>
          <div className={styles.subSectionTitle} style={{ marginTop: 16 }}>
            {configData.performance_strumenti_fondi_etf.label}
          </div>
          <PerformanceTable
            dataObject={{
              strumenti_fondi_etf: reportData.analisi_strumenti.performance_strumenti_fondi_etf,
              strumenti_obbligazionari: reportData.analisi_strumenti.performance_strumenti_obbligazionari,
              strumenti_azioni: reportData.analisi_strumenti.performance_strumenti_azioni,
              strumenti_certificati: reportData.analisi_strumenti.performance_strumenti_certificati,
              strumenti_polizze: reportData.analisi_strumenti.performance_strumenti_polizze,
              configData: { type: 'table_simple' },
            }}
          />
          {matriceData.data && Object.keys(matriceData.data).length > 1 && (
            <>
              <div className={styles.subSectionTitle} style={{ marginTop: 6 }}>
                {t('portfolio.matriceDiCorrelazione1y')}
              </div>
              <MatriceDiCorrelazione1y dataObject={matriceData} />
            </>
          )}
        </div>
      )}
      {reportData2 && (
        <div style={{ marginBottom: 0, marginLeft: 5 }}>
          <div className={styles.subSectionTitle} style={{ marginTop: 16 }}>
            {configData.performance_strumenti_fondi_etf.label + ' - ' + labels.portfolio1.toLowerCase()}
          </div>
          <PerformanceTable
            dataObject={{
              strumenti_fondi_etf: reportData.analisi_strumenti.performance_strumenti_fondi_etf,
              strumenti_obbligazionari: reportData.analisi_strumenti.performance_strumenti_obbligazionari,
              strumenti_azioni: reportData.analisi_strumenti.performance_strumenti_azioni,
              strumenti_certificati: reportData.analisi_strumenti.performance_strumenti_certificati,
              strumenti_polizze: reportData.analisi_strumenti.performance_strumenti_polizze,
              configData: { type: 'table_simple' },
            }}
          />
          <div className="force-page-break"></div>
          <div className={styles.subSectionTitle} style={{ marginTop: 35 }}>
            {configData.performance_strumenti_fondi_etf.label + ' - ' + labels.portfolio2.toLowerCase()}
          </div>
          <PerformanceTable
            dataObject={{
              strumenti_fondi_etf: reportData2.analisi_strumenti.performance_strumenti_fondi_etf,
              strumenti_obbligazionari: reportData2.analisi_strumenti.performance_strumenti_obbligazionari,
              strumenti_azioni: reportData2.analisi_strumenti.performance_strumenti_azioni,
              strumenti_certificati: reportData2.analisi_strumenti.performance_strumenti_certificati,
              strumenti_polizze: reportData2.analisi_strumenti.performance_strumenti_polizze,
              configData: { type: 'table_simple' },
            }}
          />
          {matriceData.data && Object.keys(matriceData.data).length > 1 && (
            <>
              <div className="force-page-break"></div>
              <div className={styles.subSectionTitle} style={{ marginTop: 6 }}>
                {t('portfolio.matriceDiCorrelazione1y') + ' - ' + labels.portfolio1.toLowerCase()}
              </div>
              <MatriceDiCorrelazione1y dataObject={matriceData} />
            </>
          )}
          {matriceData2?.data && Object.keys(matriceData2.data).length > 1 && (
            <>
              <div className="force-page-break"></div>
              <div className={styles.subSectionTitle} style={{ marginTop: 16 }}>
                {t('portfolio.matriceDiCorrelazione1y') + ' - ' + labels.portfolio2.toLowerCase()}
              </div>
              <MatriceDiCorrelazione1y dataObject={matriceData2} />
            </>
          )}
        </div>
      )}
    </>
  );
};
export default React.memo(
  AnalisiStrumentiContainer,
  (prevProps: SectionChildrenProps, nextProps: SectionChildrenProps) => {
    return prevProps.reportData === nextProps.reportData;
  },
);
